// extracted by mini-css-extract-plugin
export default {"container":"ForecastPage_container__pxNaL","board":"ForecastPage_board__+aqC5"};